export default {
	"route.dashboard": "レポート",
	"route.robot": "ロボット",
	"route.robotList": "ロボットリスト",
	"route.groupManage": "グループマネジメント",
	"route.disinfect": "タスク",
	"route.home": "トップページ",
	"route.disinfectTask": "タスク",
	"route.building": "ビルディング",
	"route.accessControl": "ロックドア",
	"route.ladderControl": "エレベーターコントロール",
	"route.IOT": "IOT",
	"route.accounts": "ID",
	"route.roles": "キャラクター",
	"route.jurisdiction": "権限",
	"route.dispatcher": "配達員",
	"navbar.logOut": "ログアウト",
	"login.title": "企業ID登録",
	"login.logIn": "登録",
	"login.username": "ID",
	"login.tip_username": "IDを入力してください",
	"login.password": "パスワード",
	"login.company_id": "企業ID",
	"login.tip_company": "企業IDを入力してください",
	"login.tip_pwd": "パスワードを入力してください",
	"robot.projectTtitle": "ロボット管理フラットフォーム",
	"robot.manage": "ロボット管理",
	"system.search": "検索",
	"system.reset": "リセット",
	"system.open": "オープン",
	"system.retract": "クローズ",
	"system.status": "状態",
	"system.inProgress": "進行中",
	"system.normalCompletion": "完成",
	"system.abnormalEnd": "エラーで終了",
	"system.noData": "データなし",
	"universality.confirm": "確認",
	"universality.cancel": "キャンセル",
	"universality.Pleasedonot": "スペース開かないでください",
	"universality.Pleaseifsymbols": "6~20桁の数字、英語、特殊記号を入力",
	"disinfect.robotremarkname": "ロボットの名前",
	"disinfect.EnterNoteName": "名前を入力",
	"disinfect.robotSerialNumber": "シリアルナンバー",
	"disinfect.inputSequenceNumber": "シリアルナンバーを入力",
	"disinfect.selectStatus": "状態を選択",
	"disinfect.destination": "目的地",
	"disinfect.Enterdestination": "目的地を入力",
	"disinfect.dates": "日付",
	"disinfect.tos": "まで",
	"disinfect.startDates": "開始日にち",
	"disinfect.endDates": "終了日にち",
	"disinfect.starttimes": "開始時間",
	"disinfect.endtimes": "終了時間",
	"disinfect.Lastweek": "最近の一週間",
	"disinfect.Lastmonth": "最近の一ヶ月",
	"disinfect.Lastthreemonths": "最近の三ヶ月",
	"disinfect.nonExecution": "実行していません",
	"disinfect.canceled": "キャンセル",
	"disinfect.UnclaimedProperty": "取り残されています",
	"disinfect.hardwareFailure": "ハードウェア故障",
	"disinfect.NavigationFault": "ナビエラー",
	"disinfect.Manualcancellation": "マニュアルキャンセル",
	"navigationBar.logout": "ログアウト",
	"navigationBar.logoutandsystem": "IDとシステムをログアウトしますか？",
	"account.userlist": "IDリスト",
	"account.searchnames": "IDと名前を検索",
	"account.adduser": "IDを追加",
	"account.user": "ID",
	"account.roles": "キャラクター",
	"account.ResponsibleRobot": "担当しているロボット",
	"account.name": "名前",
	"account.remark": "備考",
	"account.Recentloginiof": "最近の登録情報",
	"account.operation": "オペレーティン",
	"account.compile": "編集",
	"account.resetpasswords": "パスワードをリセット",
	"account.delete": "削除",
	"account.pleaseuserpasnumb": "6~20桁の数字、英語、特殊記号",
	"account.pleasepasswordnumb": "パスワードを入力（6~20桁の数字、英語、特殊記号を入力）",
	"account.selectroles": "キャラクター",
	"account.selectbuild": "ビルディングを選択",
	"account.inputnames": "ユーザー名を入力",
	"account.inputremarks": "備考を入力",
	"account.userdetail": "ID詳細",
	"account.platform": "台",
	"account.noBindingRobot": "バンディングしているロボットがありません",
	"account.addtimes": "時間を追加",
	"account.LastonlineTime": "最近のオンライン時間",
	"account.Resetsuccessfully": "リセット成功",
	"account.initialPassword": "初期パスワード",
	"account.gotIt": "わかりました",
	"account.PleaseRoles": "キャラクターを選択",
	"account.Pleasebuilds": "ビルディングを選択",
	"account.PleaseRobots": "ロボットを選択",
	"account.compileusers": "IDを編集",
	"account.deleteusers": "IDを削除",
	"account.Unabletologinafterdeleting": "IDを削除した後、登録できないので、削除しますか？",
	"account.alreadyexistsConfirmpasswords": "IDは既に存在しています",
	"map.deleteThecloudmap": "クラウドに保存された地図を削除すると、関連するロボットの地図も削除されます、削除しますか？",
	"map.deletemaps": "地図を削除",
	"homes.robotTotal": "累計ロボット台数",
	"homes.tasksTotal": "累計タスク個数",
	"homes.onlineTimeTotal": "トータルオンライン時間",
	"homes.nearly-7-days-onlineTime": "直近7日間のオンラインのグラフ",
	"homes.cumulativeMileage": "トータル走行距離",
	"homes.robotWorkingHoursData": "ロボット稼働時間データ",
	"homes.trendWorkingHours": "稼働時間グラフ",
	"homes.explain": "説明",
	"homes.explainContent": "ロボットが異なるビルディングでの配膳データ",
	"homes.to": "まで",
	"homes.startTime": "開始時間",
	"homes.endTime": "終了時間",
	"homes.proportionWorkingHours": "稼働時間の比率",
	"homes.buildingDeliveryList": "ビルディング配膳ランキング",
	"public.second": "回",
	"public.rice": "メートル",
	"public.lastSevenDays": "直近の7日間",
	"public.lastFourteenDays": "直近の14日間",
	"public.lastThirtyDays": "直近の30日間",
	"robotState.notActive": "アクティブされていません",
	"robotState.abnormalEnd": "エラーで終了",
	"robotState.hasLeft": "既に離れています",
	"robotState.online": "オンライン",
	"robotState.offline": "オフライン",
	"robotState.charge": "充電",
	"robotState.unknown": "未知",
	"robotState.atWork": "稼働中",
	"robotState.free": "フリー",
	"robotState.unexecuted": "実行していません",
	"robotState.executing": "実行中",
	"robotState.canceled": "キャンセルされました",
	"robotState.Completed": "完成しました",
	"robotState.nobodyTakesThings": "取り残されています",
	"robot.robotList": "ロボットリスト",
	"robot.buildings": "所属ビルディング",
	"robot.selectBuilding": "ビルディングを選択",
	"robot.search": "備考名、シリアルナンバーを検索",
	"robot.notAddRobot": "追加及びアクティブしたロボットがありません",
	"robot.mileage": "累計距離",
	"robot.information": "インフォーメーション",
	"robot.noteName": "備考名",
	"robot.model": "型番",
	"robot.onlineStatus": "オンライン状況",
	"robot.workingStatus": "稼働状況",
	"robot.currentPower": "現在バッテリ残量",
	"robot.serialNumber": "シリアルナンバー",
	"robot.operationData": "オペレティンデータ",
	"robot.latestOnlineTime": "直近のオンライン時間",
	"robot.cumulativeOnlineDuration": "累計オンライン時間",
	"robot.cumulativeDeliveryTimes": "累計配膳回数",
	"robot.cumulative-delivery-time": "累計配膳時間",
	"robot.cumulativeLeadTimes": "累計案内回数",
	"robot.cumulativeLeadTime": "累計案内時間",
	"robot.System-Hardware": "システムとハードウェア",
	"robot.systemVersion": "システムバージョン",
	"robot.hardwareStatus": "ハードウェア状態",
	"robot.language": "システム言語",
	"robot.voice_pack": "音声パック",
	"robot.box_model": "段",
	"robot.android_soft": "アンドロイドソフト",
	"robot.android_mirror": "アンドロイドミラー",
	"robot.header_control": "ヘッドコントロール",
	"robot.under_panel_version": "シャシーバージョン",
	"robot.under_mirror": "シャシーミラー",
	"robot.under_master": "シャシーマスター",
	"robot.under_control": "シャシーコントロール",
	"robot.rgbd_up": "RGBD（上）",
	"robot.rgbd_down": "RGBD（下）",
	"robot.doorControlMotor": "ドアコントローラーモーター",
	"robot.frontMountedCamera": "フロントカメラ",
	"robot.overheadCamera": "オーバーヘッドカメラ",
	"robot.infraredDetectionBox": "赤外線センサー",
	"robot.microphone": "マイク",
	"robot.radar": "ライダー",
	"robot.head-RGBD": "上部RGBD",
	"robot.bottom-RGBD": "下部RGBD",
	"robot.ultrasonicSensor": "超音波センサー",
	"robot.IMU": "IMU",
	"robot.hubMotor": "ハブモーター",
	"robot.emergencyStopSwitch": "急停止ボタン",
	"robot.horn": "スピーカー",
	"robot.getFailed": "獲得エラー",
	"robot.normal": "正常",
	"robot.abnormal": "エラー",
	"robot.cancel": "キャンセル",
	"robot.confirm": "確認",
	"public.noteNameCannotBeEmpty": "備考名を空欄してはいけません",
	"public.layer": "階",
	"public.door": "棟",
	"public.rename": "名前をリセット",
	"public.delete": "削除",
	"robot.percentageTasksCompletedTotal": "タスク完成の累計比率",
	"robotState.workSuspension": "作業一時提示",
	"buiding.buildingList": "ビルディングリスト",
	"buiding.add": "追加",
	"buiding.addFloors": "ビルディング追加",
	"buiding.pleaseCompleteBuidingsData": "左のビルディングリストに、データを入力してください",
	"buiding.map": "地図",
	"buiding.source": "ソース",
	"buiding.uploadTime": "アップロード時間",
	"buiding.pleaseRobotUploadMap": "ロボットで地図をアップロードしてください",
	"buiding.associatedBuildings": "ビルディングを関連",
	"buiding.robot": "ロボット",
	"buiding.associatedRobot": "ロボッtを関連",
	"buiding.associatedShop": "店舗を関連",
	"buiding.type": "タイプ：",
	"buiding.pleaseType": "タイプを選択してください",
	"buiding.buildingName": "ビルディング名前",
	"buiding.pleaseBuildingName": "ビルディング名を入力してください",
	"buiding.shopName": "店舗名称",
	"buiding.pleaseShopName": "店舗名称を入力してください",
	"buiding.floor": "フロア：",
	"buiding.floorName": "フロア名称：",
	"buiding.pleaseFloorName": "フロア名称：",
	"buiding.floorNameBeEmpty": "フロア名称は空欄してはいけません",
	"buiding.buid": "ビル",
	"buiding.shop": "店舗",
	"buiding.serialNumberCannotBeEmpty": "シリアルナンバーは空欄してはいけません",
	"buiding.buildingAdd": "ビルディングを追加",
	"buiding.pleaseBuilsdingName": "ビルディング名を入力してください",
	"buiding.buildingsNameBeEmpty": "ビルディング名を空欄にしてはいけません",
	"buiding.AreYouSureToDeleteThisFloor": "フロア削除しますか？",
	"buiding.deleteFloor": "フロアを削除",
	"buiding.AreYouSureToDeleteThisShop": "店舗を削除しますか？",
	"buiding.deleteShop": "店舗を削除",
	"buiding.AreYouSureToDeleteThisBuilding": "当該ビルディングを削除しますか？",
	"buiding.deleteBuilding": "ビルディングを削除",
	"buiding.editBuilding": "ビルディングを編集",
	"buiding.editFloor": "フロアを編集",
	"buiding.editShop": "店舗を編集",
	"buiding.shopNameAlreadyExists": "店舗名は既に存在しています",
	"buiding.shopAddSuccess": "店舗の追加が成功",
	"buiding.floorNameAlreadyExists": "フロア名称が既に存在しています",
	"buiding.floorAddSuccess": "フロアの追加が成功",
	"buiding.buildingNameAlreadyExists": "ビルディング名称が既に存在しています",
	"buiding.buildingAddSuccess": "ビルディングの追加が成功",
	"buiding.shopEditSuccess": "店舗の編集が成功",
	"buiding.buildingEditSuccess": "ビルディングの編集が成功",
	"buiding.floorEditSuccess": "フロアの編集が成功",
	"buiding.selectRobot": "ロボットを選択",
	"buiding.replacementBuildings": "ビルディングの変更",
	"role.rolelist": "キャラクターリスト",
	"role.addroles": "キャラクターを追加",
	"role.names": "名称",
	"role.Entername": "名称を入力",
	"role.PleaseEntername": "名称を入力してください",
	"role.editroles": "キャラクターを編集",
	"role.deleteroles": "キャラクターを削除",
	"role.Confirmdeletion": "削除したキャラクターは復活できませんので、削除しますか？",
	"role.nameAlreadyExists": "キャラクター名称は既に存在しています",
	"navigationBar.personalInfo": "個人情報",
	"navigationBar.changePassword": "パスワードを修正",
	"navigationBar.administrator": "管理員",
	"navigationBar.domesticConsumer": "普通ユーザー",
	"navigationBar.originalPsd": "オリジナルパスワード",
	"navigationBar.EnterOriginalPsd": "オリジナルパスワードを入力",
	"navigationBar.newPassword": "新パスワード",
	"navigationBar.confirmPassword": "パスワードを確認",
	"navigationBar.EntertheNewPsdAga": "新しいパスワードをもう一度入力してください",
	"navigationBar.TheOriPsdCannotEmpty": "オリジナルパスワードは空欄してはいけません",
	"navigationBar.TheNewPsdempty": "新パスワードは空欄してはいけません",
	"navigationBar.PleEntertheNewPsdAga": "新パスワードを再度入力してください",
	"navigationBar.TheNewPasastheoldone": "新パスワードと古いパスワードは一致しています",
	"navigationBar.Psdisinconsistentwith": "パスワードと新パスワークと一致しません",
	"navigationBar.modifySuccessfully": "修正成功",
	"accessControl.accessControlList": "ドアコントローラーリスト",
	"accessControl.floor": "所属フロア",
	"accessControl.accessControlAdd": "セキュリティドアを追加",
	"accessControl.accessControlID": "セキュリティドアID",
	"accessControl.selectAccessControlID": "セキュリティドアを選択",
	"accessControl.accessControlID-Hint": "セキュリティドアサービス確認、当該ユーザーは設定したセキュリティドアID",
	"accessControl.label": "備考名",
	"accessControl.pleaseLabel": "備考名を入力",
	"accessControl.deleteAccessControl-Hint": "セキュリティドアを削除すると自動ドアを通過できず、タスクの実行はできません、削除しますか？",
	"accessControl.deleteAccessControl": "セキュリティドアを削除",
	"accessControl.editAccessControl": "セキュリティドアを編集",
	"accessControl.accessControlIdExists": "セキュリティドアIDは既に存在しています",
	"public.notAssociatedFloor": "所属フロアは未関連です",
	"public.notAssociatedBuilding": "所属ビルディングは未関連です",
	"public.all": "全部",
	"public.rules.pleaseLabel": "備考名を入力してください",
	"dispatcher.dispatcherList": "配達員リスト",
	"dispatcher.searchName": "名前を検索",
	"buiding.deleteShopTips": "関連した当該店舗の全ての資産（ロボット/地図）を削除してください",
	"buiding.deleteBuidingTips": "関連した当該ビルデングの全ての資産（ロボット/地図）を削除してください",
	"buiding.deleteFloorTips": "関連した当該フロアの全ての資産を削除してください（地図）",
	"ladderControl.ladderControlList": "エレベーターコントローラーリスト",
	"ladderControl.addLadderControl": "エレバーターコントローラーを追加",
	"ladderControl.grouping": "グループ分け",
	"ladderControl.Buildings": "所属ビルディング",
	"ladderControl.You-can-go-to-the-floor": "フロアに行くことは可能",
	"ladderControl.pleaseGoToBuilding": "ビルディングに行って、エレベーターコントローラーに関連してください",
	"ladderControl.grouping-tips-1": "グループ分けは異なるエレベーターポイントに区別用",
	"ladderControl.grouping-tips-2": "1,エレベーター１台或いは同じフロアの複数のエレベーターはデフォルトグループを利用可能",
	"ladderControl.grouping-tips-3": "2、異なるフロア及びエレベーターは別のグループで区別する必要があります",
	"public.common": "棟",
	"ladderControl.ladderControlID": "エレベーターコントローラーID",
	"ladderControl.selectLadderControlID": "エレベーターコントローラーIDを選択",
	"ladderControl.ladderControlID-tips": "エレベーターコントローラー/セキュリティドアサービスと、既に設定したエレーベータIDを確認してください",
	"ladderControl.groupingPlaceholder": "入力或いはるループを選択してください（例えば、高層エレベーター）",
	"ladderControl.deleteladderControl": "エレベーターコントローラーを削除してください",
	"ladderControl.deleteladderControl-tips": "エレベーターコントローラーを削除するとロボットは複数のフロアのタスクの実行ができません、削除しますか？",
	"ladderControl.ladderControlIdExists": "エレベーターコントローラーIDは既に存在しています",
	"login.remTheNub": "パスワードを覚えておいてください",
	"login.oldPasswordError": "古いパスワードが間違っています",
	"login.confirmAndNewParrword": "2 つのパスワードが同じではありません",
	"robot.advertising": "広告",
	"homes.buildingDeliveryTimes": "配達時間",
	"robot.detail": "ロボットの詳細",
	"robot.robotModel": "ロボットタイプ",
	"robot.header_control-2": "Android電源ボード",
	"robot.under_mirror-2": "シャーシ ROM",
	"robot.under_master-2": "シャーシマスターコントロール",
	"robot.under_control-2": "シャーシ電源ボード",
	"robot.nav": "ナビゲーションアルゴリズム",
	"robot.up_rgbd": "トップ RGBD",
	"robot.down_rgbd": "下の RGBD",
	"robot.camera": "トップカメラ",
	"robot.ss": "フロントカメラ",
	"robot.rgbd_top_depth": "トップ RGBD 深度",
	"robot.rgbd_top_color": "トップRGBDカラー",
	"robot.rgbd_bottom_depth": "下の RGBD 深度",
	"robot.rgbd_bottom_color": "下の RGBD カラー",
	"robot.ultrasonic1": "左超音波",
	"robot.ultrasonic2": "右超音波",
	"robot.motor1": "左モーター",
	"robot.motor2": "右モーター",
	"robot.detection": "物体検出",
	"buiding.builNameAlreadyExists": "建物名は既に存在します",
	"robot.bindingSuccess": "バインド成功",
	"robot.notActive": "アクティブされていません",
	"robotinfo.logdown": "ログダウンロード",
	"robotinfo.Logtype": "ログの種類",
	"robotinfo.displayboard": "ディスプレイボード",
	"robotinfo.maincontrolpanel": "主制御盤",
	"robotinfo.powerstrip": "電源ボード",
	"robotinfo.navigationdata": "航法データ",
	"robotinfo.Plethedate": "日付を選択してください",
	"robotinfo.Plethetime": "時間を選択してください",
	"robotinfo.acquire": "ダウンロード",
	"robotinfo.Packinglog": "パッキングログ",
	"robotinfo.Uploadinglogfiles": "ログファイルのアップロード",
	"robotinfo.Gettinguploadstatus": "アップロード ステータスの取得",
	"robotinfo.acquiresuccess": "成功する",
	"robotinfo.clicktodownload": "クリックしてダウンロード",
	"robotinfo.Plelogtype": "ログの種類を選択してください",
	"robotinfo.Plestartdateandtime": "開始日と時間を選択してください",
	"robotinfo.Pleanenddateandtime": "終了日時を選択してください",
	"robotinfo.Nologtime": "この期間のログはありません",
	"robotinfo.logtaskispackagedpackged": "ロボットは現在、ログをパッケージ化またはアップロードしています",
	"robotinfo.failtoget": "取得できませんでした",
	"robotinfo.Failedtopackage1/2": "1/2 のパッケージ化に失敗しました",
	"robotinfo.Failedtopackage2/2": "2/2 のパッケージ化に失敗しました",
	"robotinfo.failtoupload": "アップロードに失敗しました",
	"public.unrelatedBuildings": "関連のない建物",
	"buiding.sameFloorNumber": "この建物には同じフロア番号が既に存在します",
	"navigationBar.pleaseEnterOriginalPsd": "元のパスワードを入力してください",
	"navigationBar.newpassword": "新しいパスワードを入力してください（6～20桁の英字、記号で入力してください）",
	"navigationBar.pleaseNewpassword": "新しいパスワードを入力してください",
	"login.nnterprise-number-error": "エンタープライズ ID エラー",
	"home.Fullrobot": "すべてのロボット",
	"map.displaytext": "表示テキスト",
	"map.nonetext": "テキストを表示しない",
	"robot.detection-1": "物体検出 1",
	"robot.detection-2": "物体検出 2",
	"robot.detection-3": "物体検出 3",
	"robot.detection-4": "物体検出 4",
	"robot.current_systemVersion": "現行版",
	"robot.cumulativeTimes": "配達時間",
	"robot.cumulativeTime": "納期",
	"home.hour": "時間",
	"home.min": "分",
	"home.deliverytimes": "納期（回）",
	"login.actpaswdinco": "ユーザーネームまたはパスワードが違います",
	"login.enterpriseerror": "エンタープライズ ID エラー",
	"home.numberofworkmachs": "作業ロボット数",
	"home.workinghours": "労働時間",
	"login.account_expired": "アカウントの有効期限が切れています。もう一度ログインしてください",
	"robot.CADEBOT_rankingList_tips": "お届け先ランキング",
	"robot.setLabel": "コメントを設定しました",
	"homes.nearly-7-days-mileage": "過去 7 日間の走行距離の傾向",
	"robot.robotisofflineobtalogs": "ロボットがオフラインで、ログを取得できません",
	"buiding.buid-illustrate": "Gebäude (für mehrere Stockwerke)",
	"buiding.shop-illustrate": "Geschäft (für ein Stockwerk)",
	"buiding.new-pleaseFloorName": "Bitte geben Sie den Namen der Etage ein",
	"route.admage": "広告",
	"route.asset": "素材ライブラリ",
	"route.ads": "広告掲載について",
	"route.adsDetail": "広告の詳細",
	"route.addAds": "広告を追加する",
	"route.editAds": "広告を編集する",
	"ad.asset": "リソース一覧",
	"ad.freeSpace": "残りスペース",
	"ad.uploadAsset": "リソースのアップロード",
	"ad.filename": "ファイル名",
	"ad.type": "タイプ",
	"ad.memory": "メモリ",
	"ad.video": "動画",
	"ad.image": "画像",
	"ad.uploadTime": "アップロード時間",
	"ad.uploadProgress": "アップロードの進捗状況",
	"ad.uploadSuccess": "アップロード成功",
	"ad.operation": "操作方法",
	"ad.check": "表示",
	"ad.delete": "削除",
	"ad.confirm": "確認",
	"ad.cancel": "キャンセル",
	"ad.deleteSuccess": "削除に成功",
	"ad.back": "戻る",
	"ad.deleteAsset": "リソースを削除する",
	"ad.deleteAssetWarningMessage": "削除したリソースは復元されませんので、削除を確認してください。",
	"ad.extLimit": "アップロードできるファイルは、JPG、PNG、MP4、AVI、MOV、WMV、RMVB形式のみです。",
	"ad.sizeLimit": "個々のファイルは1GBを超えることができません",
	"ad.syncFail": "ダウンロードに失敗しました",
	"ad.syncComplete": "ダウンロード完了",
	"ad.downloadComplete": "設定中",
	"ad.downloadWaiting": "ダウンロードされていない",
	"ad.name": "名前",
	"ad.playTime": "再生時間帯",
	"ad.materialNum": "エレメント数",
	"ad.robotNum": "ロボット投下数",
	"ad.startTime": "投稿時間",
	"ad.addSchema": "広告の追加",
	"ad.copySchema": "コピープログラム",
	"ad.edit": "編集",
	"ad.publish": "投稿",
	"ad.deleteDraft": "番組を削除する",
	"ad.save": "保存",
	"ad.preview": "プレビュー",
	"ad.setDefault": "今すぐ使う",
	"ad.setDefaultPlease": "デフォルトの場合は設定してください。",
	"ad.yes": "はい",
	"ad.no": "いいえ",
	"ad.deleteDraftWarningMessage": "番組の削除を確認しますか？",
	"ad.draft": "掲載しない",
	"ad.schemaDetail": "番組の詳細",
	"ad.schemaContent": "番組内容",
	"ad.syncRecord": "シンクロ録画",
	"ad.robotSn": "ロボットを投下する",
	"ad.robotSelect": "ロボットを選ぶ",
	"ad.nameInput": "番組名を入力してください",
	"ad.robotSelectPlease": "ロボットを選択してください",
	"ad.nameInputPlease": "プラン名を入力してください",
	"ad.materialList": "素材リスト",
	"ad.materialListDescriptions": "広告画面の寸法: 1080*1920。 ドラッグして順番を変えます。",
	"ad.setting": "プレイスメント設定",
	"ad.period": "タイムスロット",
	"ad.allDay": "一日中",
	"ad.someTime": "時間帯別",
	"ad.beginTime": "開始時間",
	"ad.endTime": "終了時間",
	"ad.materialLib": "素材ライブラリ",
	"ad.materialNumber": "素材数",
	"ad.removeScreen": "分割画面を削除する",
	"ad.removeScreenConfirm": "分割画面の削除を確認しますか？",
	"ad.playTimeDuration": "再生時間",
	"ad.picturePlayTime": "画像再生の長さ",
	"ad.addPeriod": "タイムスロットを追加する",
	"ad.addPeriodLimit": "6種類のタイムスロットを追加することができます。",
	"ad.totalTime": "合計時間",
	"ad.saveSuccess": "保存に成功",
	"ad.publishSuccess": "投稿成功",
	"ad.addPeriodFail": "すでに1日分の枠があるため、追加できません。",
	"ad.publishFail": "投稿に失敗しました",
	"ad.playTimeNoEmpty": "プレイタイムを空にすることはできません",
	"ad.materialListNoEmpty": "素材リストの分割画面を空にすることはできません",
	"ad.robot": "ロボット",
	"ad.robotOffline": "オフラインのロボット",
	"ad.robotOfflineAndCanNotLaunch": "以下のロボットはオフラインのため、配置することができません。",
	"ad.robotUplineOrSaveDraft": "ロボットをインターネットに接続するか、提案書を下書きとして保存しておいてください。",
	"ad.syncStatus": "ロボットのダウンロードステータス",
	"ad.reSync": "再発行",
	"ad.goBackList": "リストに戻る",
	"ad.confirmPublish": "本当に投稿しますか？",
	"ad.robotOfflineToConfirmPublish": "以下のロボットがオフラインになっていますが、解除の確認はできますか？",
	"ad.addCancelConfirm": "戻ったときに現在のコンテンツが保存されていないことは確認されていますか？",
	"ad.refresh": "リフレッシュする",
	"ad.publishTime": "投稿時間",
	"ad.lastModifyTime": "最終更新日",
	"ad.publisher": "投稿者",
	"ad.editor": "変更者",
	"ad.timeOverlap": "プレイセッションは重複できませんので、ご確認ください。",
	"ad.endTimeMustLargerThanStartTime": "プレイセッションの終了時刻は開始時刻より大きくなければなりません。",
	"ad.cannotDeleteAssetUsed": "このクリップは参照されているため、削除することはできません",
	"ad.deletePeriodWarningMessage": "タイムスロットの削除を確認する？",
	"ad.complete": "完了",
	"ad.fail": "失敗しました",
	"ad.nameInputIllegal": "番組名に特殊文字は使用できません",
	"ad.nameDuplicate": "番組名がすでに存在する",
	"ad.updateTime": "最新の変更時間",
	"role.TherolesDeletingfails": "この文字はアカウントに関連付けられ、削除に失敗しました。",
	"account.Changeofauthority": "権限が変更されました",
	"account.ThepermisschgePleaseagain": "アカウントのパーミッションが変更されました",
	"disinfect.Unknowncause": "理由は不明です。",
	"robot.accumulatedTaskExecutionTimes": "タスクの累積実行回数",
	"home.minute": "分",
	"homes.Statisticstasks": "ロボットが実行したタスクの統計（ワークインプログレス）",
	"disinfect.Initilizati": "初期化が失敗しました",
	"disinfect.Failedtogetlocation": "現在地を取得できませんでした",
	"disinfect.pointisoffthemap": "目的地がマップの外にある",
	"disinfect.onastaticobstacle": "目的地は障害物上にあります",
	"disinfect.therearenoroadsonthestaticmap": "静的マップには道路がありません",
	"disinfect.Startingpointobstacle": "スタートに障害物あり",
	"disinfect.Lossoflocation": "位置を測定できません",
	"disinfect.Failedtolocatethelostlocalpath": "部分的ルートの計画できません",
	"disinfect.Clifftriggercancellation": "段差を検出したので、タスクをキャンセルしました",
	"disinfect.Emergencystoptriggerscancellation": "非常停止命令のため、タスクをキャンセルしました",
	"disinfect.Collisionbartriggercancel": "衝突防止ストリップで、タスクをキャンセルしました",
	"disinfect.overtime": "タイムアウト",
	"disinfect.Chargingpiledetectionfailed": "充電台の検出に失敗しました",
	"disinfect.Pilefailure": "充電台への接続が失敗しました",
	"disinfect.GlobalpathplanningfailedProcedure": "全体リートを作成できませんでした",
	"disinfect.Slopetriggercancellation": "傾斜度を検出したので、タスクをキャンセルしました",
	"disinfect.NavigationrecoverybeProcedure": "ナビゲーションの回復動作に失敗",
	"disinfect.Navigateoutnarrowchannel": "ナビゲートエグジットナローチャネル",
	"disinfect.Androidtasktimeout": "Androidタスクのタイムアウト",
	"disinfect.elsesa": "その他のエラー",
	"robot.historicaldelete": "このロボットの履歴データは削除されます、削除を確認しますか？",
	"robot.delfaild": "削除に失敗しました",
	"robot.LoRa_ID": "LoRa ID",
	"robot.associatedSIMCard": "関連するSIMカード",
	"robot.accumulatedUsageTraffic": "累積トラフィック使用量",
	"robot.trafficUsageMonth": "今月使用したトラフィック",
	"robot.newrgbd_bottom_depth": "下の RGBD 深度",
	"robot.batteryTest": "バッテリーテスト",
	"robot.Partial_information_update_failed": "一部の情報の更新に失敗しました",
	"robot.update_failed": "アップデートに失敗しました",
	"robot.update_robot_datasSuccess": "ロボットの最新データを正常に取得",
	"ad.waitForDownload": "ダウンロードを待っています",
	"ad.startDownload": "ダウンロード開始",
	"ad.offLineAndCannotDownload": "デバイスがオフラインのためダウンロードできません",
	"ad.syncing": "同期しています...",
	"robot.robot_does_not_exist": "ロボットは存在しない",
	"robot.robot_current_enterprise": "ロボットは現在の企業から去った",
	"ad.notEnoughSpace": "エンタープライズ資料用の十分なスペースがありません。時間内にファイルをクリーンアップしてください。",
	"ad.addAsset": "材料を追加する",
	"robot.batteryCommunication": "バッテリー通信",
	"disinfect.Thetargetpointisobstacle": "ターゲット ポイントは動的障害物上にあります",
	"disinfect.Therearenoroadsonadynamicmap": "ダイナミックマップには道路がありません",
	"robot.buildingRobotErrorTips_10019": "この店舗のロボットの数が上限の 16 に達しました。建物 (店舗) を変更してください。",
	"robot.buildingRobotErrorTips_10020": "LoraId の生成中にエラーが発生しました",
	"map.VirtualWall": "バーチャルウォール",
	"map.tracks": "ルート",
	"map.Qrcode": "QRコード",
	"map.regions": "エリア",
	"map.anchorpoints": "位置決めポイント",
	"robot.noSearchResults": "検索結果がありません",
	"robot.accountInformationHasBeenModified": "アカウント情報が変更されました",
	"public.tips": "ヒント",
	"public.agreeWith": "同意",
	"public.iHaveReadAndAgree": "読んで同意します",
	"public.userAgreement": "ユーザー規約",
	"public.gentle": "と",
	"public.privacyAgreement": "プライバシーポリシー",
	"public.pleaseAgreeFirst": "まずは同意してください",
}